import { motion } from "framer-motion";
import { useLocale } from "next-intl";
import { useGetCycle } from "../hooks/main-hooks";

export default function Cycle() {
  const { data } = useGetCycle();
  const locale = useLocale();

  const steps = data?.data || [];

  return (
    <div className="space-y-16">
      <h3 className="text-center text-3xl font-black text-[#0a1b2e]">
        {locale === "en" ? "Project Cycle" : "دورة المشروع"}
      </h3>

      <div className="relative grid gap-8 md:grid-cols-4">
        {/* Connecting Line */}
        <div className="absolute left-0 right-0 top-10 hidden h-px bg-linear-to-r from-transparent via-[#c9a24d]/40 to-transparent md:block" />

        {steps.map((step: any, i: number) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.15 }}
            viewport={{ once: true }}
            className={`relative rounded-xl border border-slate-200 bg-white p-6 shadow-sm ${
              i + 1 === 9 || i + 1 === 10 ? "md:col-span-2" : ""
            } `}
          >
            <span className="text-5xl font-black text-white bg-brand-mustard w-16 h-16 flex items-center justify-center rounded-full">
              {i + 1}
            </span>
            <h4 className="mt-4 mb-2 text-xl font-bold text-[#0a1b2e]">
              {step?.name?.[locale]}
            </h4>
            <p className="text-[#132b44]">{step?.description?.[locale]}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
